import { render, staticRenderFns } from "./AdminTradeDownPay.vue?vue&type=template&id=24a0181e&scoped=true&"
import script from "./AdminTradeDownPay.vue?vue&type=script&lang=js&"
export * from "./AdminTradeDownPay.vue?vue&type=script&lang=js&"
import style0 from "./AdminTradeDownPay.vue?vue&type=style&index=0&id=24a0181e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a0181e",
  null
  
)

export default component.exports